import React from "react";
import TopBar from "./TopBar";
import MenuBar from "./MenuBar";
import PageContent from "../content/PageContent";
import FooterBottom from "../footer/FooterBottom";
function NavBar() {
  return (
    <div>
      <TopBar />
      <MenuBar />
      <PageContent />
      <FooterBottom />
    </div>
  ); 
};
export default NavBar;